// Point to full path because package.json does not contain a `main` property
import 'jquery-tooltipster/js/jquery.tooltipster.min.js';

$('.js-tooltip').tooltipster({
    functionBefore: function (origin, continueTooltip) {
        origin.tooltipster('content', origin.children('.js-tooltip-content').html());
        continueTooltip();

    },
    interactive: 'true',
    animation: 'fade',
    delay: 200,
    theme: 'tooltipster-shadow',
    contentAsHTML: true,
    touchDevices: true,
    trigger: 'hover'
});